module.exports = ["Min","Max","Min Id","Max Od","Min Height","Max Height","Max Length","Min Weight","Max Weight","Max Diam","Disc Max Diam","Ring Max Diam","Ring Max Length","Shaft Max Length","Cold Min Lbs","Cold Max Lbs"]


//////////////////
// WEBPACK FOOTER
// ./src/config/materialDimensions.json
// module id = 5424
// module chunks = 1